<template>
  <section class="terms-conditions">
    <div class="container">
      <div class="terms-conditions__wrapper col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
        <div class="row push-v--desktop--large push-v--tablet--large push-v--mobile--x-small">
          <div class="col-12 col-md-6 text-center--mobile">
            <h1 class="terms-conditions__title push-v--mobile--x-small">{{ title }}</h1>
          </div>
          <div v-if="date" class="col-12 col-md-6 text-right--desktop text-right--tablet text-center--mobile">
            <p class="terms-conditions__date text--faux push-v--mobile--small">{{ date }}</p>
          </div>
        </div>
        <h3 v-if="subtitle" class="terms-conditions__subtitle">{{ subtitle }}</h3>
        <div v-html="body" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: { type: String, default: 'Terms of use' },
    subtitle: { type: String, default: 'General' },
    date: { type: String, default: 'Valid as of 25 May 2018' },
    body: {
      type: Array,
      default() {
        return [
          {
            body:
              '<p>The use of "The Collective", "we", "our" and "us" means The Collective (Living) Limited, a limited company registered in England & Wales with registration number 07271022. Our registered office is at 14 Bedford Square, London, WC1B 3JA.</p>',
            link: '',
            linkText: '',
          },
          {
            body:
              '<p>The use of "The Collective", "we", "our" and "us" means The Collective (Living) Limited, a limited company registered in England & Wales with registration number 07271022.</p>',
            link: 'https://google.com',
            linkText: 'This is a web link inside text.',
          },
          {
            body:
              '<p>The use of "The Collective", "we", "our" and "us" means The Collective (Living) Limited, a limited company registered in England & Wales with registration number 07271022. Our registered office is at 14 Bedford Square, London, WC1B 3JA.</p>',
            link: '',
            linkText: '',
          },
        ];
      },
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_terms-conditions.scss';
</style>
